$(".btn-menu").on("click", function() {
  $(this).toggleClass("btn-menu--active");
  $(".languages").toggleClass("languages--active");
  $(".overlay-mask-menu").toggleClass("overlay-mask-menu--active");
});
